import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, of, switchMap, timer } from 'rxjs';

@Component({
  selector: 'math-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);

  /**
   * Поток, управляющий состоянием загрузки.
   * Если навигация длится дольше 200мс, эмитит true.
   * Как только навигация завершается, эмитит false.
   */
  protected readonly isLoading = toSignal(
    this.router.events.pipe(
      switchMap((event) => {
        if (!isPlatformBrowser(this.platformId)) {
          return of(false);
        }

        if (event instanceof NavigationStart) {
          // Запускаем таймер. Если за 200мс навигация не закончится, покажем спиннер.
          return timer(200).pipe(map(() => true));
        }

        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          // Навигация завершена — мгновенно скрываем спиннер
          return of(false);
        }

        // Для всех прочих событий (RoutesRecognized и т.д.) не меняем состояние
        // Но switchMap должен что-то вернуть, поэтому возвращаем текущее состояние "не грузится"
        // либо игнорируем, если мы уже в процессе ожидания.
        // Однако для простоты и корректности сброса возвращаем константу,
        // так как NavigationStart всегда будет идти первым.
        return [];
      }),
    ),
    { initialValue: false },
  );
}
